module.exports = __webpack_public_path__ + "img/old1.6cd7e234.jpg";